module.exports = __webpack_public_path__ + "static/media/iv_profile.f3ee96e1.svg";